<template>
  <div id="laureat" class="searchLaureat" :class="{entered, searching: !laureats || laureats.length < 1}">
    <div class="searchHide">
      <div class="top">
        <div class="upper">
          <div class="title" v-if="!laureats || laureats.length < 1">Rechercher</div>
          <div class="title" v-else v-html="search"></div>

          <div class="close" v-if="laureats && laureats.length > 0" @click="removeSearch">
            <div class="closeInner">&times;</div>
          </div>
        </div>
      </div>

      <div id="searchBox" v-show="!laureats || laureats.length < 1">
        <div id="searchBoxInner">
          <input v-model="search" type="text" placeholder="Nom..." @keyup.enter="getfilteredData">
          <input id="submit" type="submit" value="Valider" @click="getfilteredData">
          <div class="warning">
            <p v-if="laureats.length < 1">Aucun résultat trouvé</p>
            <p v-else>&nbsp;</p>
          </div>
        </div>
        <br>
      </div>

      <div v-if="laureats && laureats.length > 0" class="laureatContainer">
        <Laureat v-for="(item, index) in laureats" :item="item" :key="item.title + index" :index="index"/>
      </div>
    </div>

    <transition name="l-fade" mode="out-in" appear @after-enter="afterEnter">
      <router-view :key="$route.params.slug"/>
    </transition>
  </div>
</template>

<script>
import Laureat from '@/components/Laureat'
import setLaureat from '@/components/setLaureat'

export default {
  data () {
    return {
      entered: false,
      selected: false,
      search: '',
      filteredData: false,
      laureats: false
    }
  },

  mixins: [setLaureat],

  components: {
    Laureat
  },

  computed: {
    all () {
      return this.$store.getters.all
    }
  },

  methods: {
    removeSearch () {
      this.filteredData = false
      this.laureats = false
      this.search = ''
    },

    afterEnter () {
      this.entered = true
    },

    randOrd () {
      let current = this.filteredData
      // Set size and randomize project order
      let j
      let x
      let i

      for (i = 0; i < current.length; i++) {
        x = current[i]
        j = Math.floor(Math.random() * (i + 1))
        current[i] = current[j]
        current[j] = x
      }

      current.forEach((item, index) => {
        this.setLaureat(item, index, current)
      })

      let nArr = []
      current.forEach((item, index) => {
        if (item.col === 2) {
          nArr.splice(index - 1, 0, item)
        } else {
          nArr.push(item)
        }
      })

      this.laureats = nArr
      this.$store.commit('editState', { state: 'currentLoop', data: nArr })
    },

    getfilteredData () {
      let filterData = (array, filter) => {
        return array.filter((item) => {
          if (item.title.toLowerCase().includes(filter)) {
            return true
          }

          return false
        })
      }

      if (this.search !== '') {
        this.filteredData = filterData(this.all, this.search.toLowerCase())
        this.randOrd()
      }
    }
  },

  watch: {
    '$route' (to, from) {
      if (from.name === 'laureats-laureat' && to.name === 'laureats') {
        this.entered = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
.searchHide {
  background-color: white;
  border: 1px solid transparent;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  transition: opacity $ease ease;
  position: fixed;
  width: 100%;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 4rem calc(#{$menu} + 2rem);
  top: 0;
  left: 0;
}

.searching .searchHide {
  padding-bottom: 4rem;
  position: absolute;
}

.page-laureats {
  #laureat {
    padding-bottom: 0;
  }
}

#searchBox {
  margin: 2rem 0;
  text-align: center;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: $mediumtype;
}

#searchBoxInner {
  width: 30%;
  margin: 0 auto;

  input, #submit {
    width: 100%;
    color: $maincolour;
    height: $menu;
    text-align: center;
    border: $line;
    outline: none;
    font-size: $mediumtype;
    margin-bottom: 1rem;
    border-radius: 0;
    -webkit-appearance: none;
    -webkit-text-fill-color: $maincolour;
  }

  #submit {
    cursor: pointer;
    background-color: $maincolour;
    color: white;
    -webkit-text-fill-color: white;
  }
}

.laureatListItem {
  padding: 0.5rem 0 0.3rem;
  border-bottom: $line;
}

.laureatListItem:last-child {
  border-bottom: 0;
}

.warning {
  color: red;
}

@media screen and (max-width: $breakPoint1) {
  .laureatListItem {
    border-bottom: $line2;
  }

  #searchBoxInner {
    width: 100%;
  }

  .page-laureats {
    .searching .searchHide {
      z-index: 1;
      padding-top: calc(#{$moblogo} + 4rem);
    }

    .searchHide {
      z-index: 2;
      min-height: auto;

      .laureatContainer {
        padding: 0;

        .laureat:last-child {
          padding-bottom: calc(#{$menu} + 2rem);
        }
      }
    }
  }

  #searchBoxInner {
    input, #submit {
      border: $line2;
    }
  }
}
</style>
